var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('nav',{attrs:{"color":"primary","padless":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},_vm._l((_vm.menus),function(menuItem,key){return _c('v-btn',{key:key,staticClass:"my-2 mx-1",attrs:{"color":"white","text":"","rounded":"","to":menuItem.path}},[_vm._v(" "+_vm._s(_vm.$t(menuItem.name))+" ")])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }